import { createAction } from '@reduxjs/toolkit';
import {
  DownloadProgress,
  DownloadRequest,
  GridItemEntities,
  HTMLPreviewResponse,
  QueryResultsActionTypes,
  QueryResultsRequest,
  TabularResponsePayload
} from './models';

export const loadQueryResultsStart = createAction(
  QueryResultsActionTypes.LOAD_QUERY_RESULTS_START,
  (payload: QueryResultsRequest) => ({payload})
);

export const loadTabularDataSuccess = createAction(
  QueryResultsActionTypes.LOAD_TABULAR_DATA_SUCCESS,
  (payload: TabularResponsePayload) => ({payload})
);

export const loadTabularDataFailure = createAction(
  QueryResultsActionTypes.LOAD_TABULAR_DATA_FAILURE,
  (payload) => ({payload})
);

export const loadHTMLPreviewStart = createAction(
  QueryResultsActionTypes.LOAD_HTML_PREVIEW_START,
  (payload: QueryResultsRequest) => ({payload})
);

export const loadHTMLPreviewSuccess = createAction(
  QueryResultsActionTypes.LOAD_HTML_PREVIEW_SUCCESS,
  (payload: HTMLPreviewResponse) => ({payload})
);

export const loadHTMLPreviewFailure = createAction(
  QueryResultsActionTypes.LOAD_HTML_PREVIEW_FAILURE,
  (payload) => ({payload})
);

export const loadQDSearchStart = createAction(
  QueryResultsActionTypes.LOAD_QDSEARCH_START,
  (payload: QueryResultsRequest) => ({payload})
);

export const loadQDSearchSuccess = createAction(
  QueryResultsActionTypes.LOAD_QDSEARCH_SUCCESS,
  (payload: TabularResponsePayload) => ({payload})
);

export const loadQDSearchFailure = createAction(
  QueryResultsActionTypes.LOAD_QDSEARCH_FAILURE,
  (payload) => ({payload})
);

export const selectForDownload = createAction(
  QueryResultsActionTypes.SELECT_FOR_DOWNLOAD,
  (payload: GridItemEntities) => ({payload})
);

export const resetForDownload = createAction(QueryResultsActionTypes.RESET_FOR_DOWNLOAD);

export const loadDownloadStart = createAction(
  QueryResultsActionTypes.LOAD_DOWNLOAD_START,
  (payload: DownloadRequest) => ({payload})
);

export const loadDownloadSuccess = createAction(
  QueryResultsActionTypes.LOAD_DOWNLOAD_SUCCESS
);

export const loadDownloadFailure = createAction(
  QueryResultsActionTypes.LOAD_DOWNLOAD_FAILURE,
  (payload) => ({payload})
);

export const loadDownloadProgress = createAction(
  QueryResultsActionTypes.LOAD_DOWNLOAD_PROGRESS,
  (payload: DownloadProgress) => ({payload})
);

export const loadDownloadCancel = createAction(
  QueryResultsActionTypes.LOAD_DOWNLOAD_CANCEL
);